import React from 'react';
import { CardMedia, Box, Typography, Grid } from '@mui/material';
import gwpBackground from '../../Assets/GWPBackground.jpg';
import { trakrefFontFamily, trakrefFontFamilySemiBold } from '../../../utils';
import { Translate, TranslateW } from '../../../Utils/Languages/Translate';
import PropTypes from 'prop-types';

const textStyle = { fontFamily: trakrefFontFamily, color: '#fff' };

const GlobalWarmingPotential = ({
    tonsAmount,
    marginTop,
}) => (
    <Box
        sx={{
            position: 'relative',
            marginTop: `${marginTop}%`,
            marginRight: 0,
            marginLeft: 'auto',
            width: '100%',
            height: '140px'
        }}
    >
        <CardMedia
            component="img"
            height="150px"
            image={gwpBackground}
            sx={{ borderRadius: '5px' }}
        />
        <Box
            sx={{
                position: 'absolute',
                top: '3vh',
                left: 0,
                width: '100%',
                height: '140px',
                color: 'white',
                marginBottom: 0
            }}
        >
            <Grid
                container
                spacing={1}
                justifyContent='center'
                sx={{ width: '100%', marginLeft: 0 }}
            >
                <Grid item xs={12}>
                    <Typography
                        variant="h5"
                        sx={{ ...textStyle, fontSize: {xs: '.9rem', lg: '1.15rem'} }}
                    >
                        {TranslateW("GlobalWarmingPotential.header")}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography 
                        variant="body2"
                        sx={{ ...textStyle, fontSize: '.60rem' }}
                    >
                        {TranslateW("GlobalWarmingPotential.explanation")}
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={{ paddingTop: '0px' }}>
                    <Typography
                        variant="body2"
                        sx={{ ...textStyle, fontSize: '.75rem' }}
                    >
                        <Box
                            component='span'
                            sx={{ fontFamily: trakrefFontFamilySemiBold, color: '#fff', fontSize: '1.95rem' }}
                        >
                            {tonsAmount}
                        </Box>
                        {TranslateW("GlobalWarmingPotential.tonsCO2")}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    </Box>
);

GlobalWarmingPotential.propTypes = {
    tonsAmount: PropTypes.number.isRequired,
    marginTop: PropTypes.number.isRequired,
};
  
export default GlobalWarmingPotential;
